import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faMobileScreen, faComment } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import HCaptcha from '@hcaptcha/react-hcaptcha';

import config from '../config';
import Api from '../api';
import Loader from "../pLoader";

const GetContent = ({ lang, setStateLang, curPage, setCurPage }) => {
    var captcha=false;
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState([]);
    const [errors, setErrors] = useState({});

    const handleError = () => {
      const elements = document.querySelectorAll(".error-msg");
      elements.forEach((el) => {
        const elfor = el.getAttribute('name');
        if(errors[elfor] !== undefined && errors[elfor]!=="" && errors[elfor].length>0){
          el.innerHTML=errors[elfor];
          el.classList.add("error");
          el.classList.remove("hide");
        } else {
          el.innerHTML="";
          el.classList.add("hide");
          el.classList.remove("error");
        }
      });
    };

    const handleFileChange = (e) => {
      const selectedFiles = Array.from(e.target.files);
      const maxSize = config.file_size * 1024 * 1024; // 2 MB
      var er = errors

      const validFiles = [];
      for (let file of selectedFiles) {
        if (!config.supported_files.includes(file.type)) {
          er.file=file.name+" is not an allowed file type! you can upload only "+(config.supported_files.join(", "));
          setErrors(er)
          handleError()
          continue;
        } else if (file.size > maxSize) {
          er.file=file.name+" is too large! Max size is 2 MB";
          setErrors(er)
          handleError()
          continue;
        } else {
          delete er.file;
        }
        validFiles.push(file);
      }
      setErrors(er)
      handleError()
      setFiles(validFiles)
    };

    const validateEmail = () => {
      var value=document.getElementById("from_email").value;
      var er = errors
      // Basic regex (covers most valid emails)
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if(!regex.test(value)){
        er.email="Invalid Email Address";
      } else {
        delete er.email;
      }
      setErrors(er);
      handleError()
    };

    const validateMobile = () => {
      var value=document.getElementById("mobile_no").value;
      var er = errors
      const regex = /^[0-9]{10}$/; // allows only 10 digits
      
      if(!regex.test(value)){
        er.mobile="Invalid Mobile Number";
      } else {
        delete er.mobile;
      }
      setErrors(er);
      handleError()
    };

    const handleVerificationSuccess = (token,ekey) => {
      captcha=true;
    }

    const sendEmail = async (e) => {
      e.preventDefault();
      if (config.environment==='prod' && !captcha) {
        alert("Please verify the captcha!");
        return;
      }
      handleError()

      validateEmail()
      validateMobile()
      if(Object.keys(errors).length>0){
        alert("Fix the shows Errors to submit Query");
        return;
      }
      
      const formData = new FormData(e.target);
      const fdata = Object.fromEntries(formData.entries());
      for (let i = 0; i < files.length; i++) {
        formData.append("attachments", files[i]);
      }

      var msg = "<p>Dear <strong>Team</strong>,</p>";
      msg += "<p><strong>Name :</strong> "+fdata.from_name+"<br/><strong>Email :</strong> "+fdata.from_email+"<br/><strong>Mobile No :</strong> "+fdata.mobile_no+"<br/></p>";
      msg += "<p>A Query recevied from above person through sriammanconsultants.in and below is the message. Please look into the same and address it asap.</p>";
      msg += "<p><strong>Message:</strong><br/>"+fdata.remarks+"</p>";
      if(files !== undefined && files !== null)
        msg += "<p>Note: Attachment received pls verify the same too.</p><br/><br/><br/>";
      msg += "<p>Thanks & Regards,</p>";
      msg += "<p>Support Team.</p>";
      formData.append("message", msg);
      formData.append("to_email", config.to_email);
      formData.append("cc_email", config.cc_email);
      formData.append("bcc_email", config.bcc_email);
      formData.append("subject", "Query: Query received from sriammanconsultants.in");
      
      try {
        setLoading(true);
        //return true;
        const result = await Api.sendMail(formData);
        if(result){
          alert("Query Submitted! Please wait for a reply from our team");
        } else {
          alert("Error: Sending mail, please try again.")
        }
      } catch(e){
        alert("Error: Unable to make API calls")
      } finally {
        setLoading(false);
      }
    };

    return (
        <div className='container page-body'>
          {loading && <Loader />}
          <h2 className="p-4">{ config.pg_content.nav["contactus"][lang] }</h2>
          <div className="row">
            <div className="col-md-5 shadow py-3 rounded">
              <iframe title="Map Location" className="w-100" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1388.1339887373472!2d77.488525069135!3d10.242554685705361!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b07668a1572b3e5%3A0x2b035a554e9e0a85!2sKodaikanal%2C%20Tamil%20Nadu%20624101!5e0!3m2!1sen!2sin!4v1757422757537!5m2!1sen!2sin" width="500" height="450" loading="lazy"></iframe>
            </div>
            <div className="col-md-7 border-start p-3">
              <div className="row">
                  <div className="col-md-6">
                      <h5 className="org-name">Sri Amman Consultants</h5>
                      <p className="org-address">Accounting & Tax Services <br/>
                      17/54, Convent Road, GEORGE Cottage,<br/>
                      Near Sri Venkateswara Battry Store,<br/>
                      Dindigul Dt.<br/>
                      Kodaikanal - 624101</p>
                  </div>
                  <div className="col-md-6">
                      <p><FontAwesomeIcon icon={faEnvelope} size="1x" color="black" /> <a href="mailto:taxadviserskodai@gmail.com" >taxadviserskodai@gmail.com</a></p>
                      <p><FontAwesomeIcon icon={faMobileScreen} size="1x" color="black" /> 9865308498</p>
                      <p><FontAwesomeIcon icon={faComment} size="1x" color="black" /> 9865308498</p>
                  </div>
              </div>
              <form className="form" onSubmit={sendEmail}>
              <fieldset className="border border-primary shadow rounded">
                <h5 className="org-name bg-primary p-2 text-white" >Post your Query</h5>
                <div className="row p-1">            
                  <div className="col-md-6">
                    <input className="form-control" type="text" id="from_name" name="from_name" placeholder="Your Name" required />
                  </div>
                  <div className="col-md-6">
                    <input className="form-control" type="email" id="from_email" name="from_email" placeholder="Your Email" required onBlur={validateEmail} />
                    <p name="email" className="error-msg text-danger px-1" >{errors.email}</p>
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-md-6">
                    <input className="form-control" type="text" id="mobile_no" name="mobile_no" placeholder="Your Mobile No" required onBlur={validateMobile} />
                    <p name="mobile" className="error-msg text-danger px-1" >{errors.mobile}</p>
                  </div>
                  <div className="col-md-6">
                    <input className="form-control"  type="file" name="my_file" multiple onChange={handleFileChange} />
                    <p name="file" className="error-msg text-danger px-1" >{errors.file}</p>
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-md-12">
                    <textarea className="form-control" name="remarks" placeholder="Your Message" required />
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-md-6">
                    <HCaptcha
                      sitekey="5cbcbea2-b502-4618-b040-c1f456fe9a7c"
                      onVerify={(token,ekey) => handleVerificationSuccess(token, ekey)}
                    />
                  </div>
                  <div className="col-md-6 text-center">
                    <button className=" btn btn-lg btn-primary align-center" type="submit" > &nbsp; Send &nbsp; </button>                
                  </div>
                </div>
              </fieldset>
              </form>
            </div>
          </div>
        </div>
    );
}

export default GetContent;